/* Earlsmere label designer — generated bundle. Edit src/*.js and re-run build/build.py. */
(function(){
/* Generated lookup tables - do not hand-edit. Source: python-barcode + qrcode. */
var C128_CODES = ["11011001100", "11001101100", "11001100110", "10010011000", "10010001100", "10001001100", "10011001000", "10011000100", "10001100100", "11001001000", "11001000100", "11000100100", "10110011100", "10011011100", "10011001110", "10111001100", "10011101100", "10011100110", "11001110010", "11001011100", "11001001110", "11011100100", "11001110100", "11101101110", "11101001100", "11100101100", "11100100110", "11101100100", "11100110100", "11100110010", "11011011000", "11011000110", "11000110110", "10100011000", "10001011000", "10001000110", "10110001000", "10001101000", "10001100010", "11010001000", "11000101000", "11000100010", "10110111000", "10110001110", "10001101110", "10111011000", "10111000110", "10001110110", "11101110110", "11010001110", "11000101110", "11011101000", "11011100010", "11011101110", "11101011000", "11101000110", "11100010110", "11101101000", "11101100010", "11100011010", "11101111010", "11001000010", "11110001010", "10100110000", "10100001100", "10010110000", "10010000110", "10000101100", "10000100110", "10110010000", "10110000100", "10011010000", "10011000010", "10000110100", "10000110010", "11000010010", "11001010000", "11110111010", "11000010100", "10001111010", "10100111100", "10010111100", "10010011110", "10111100100", "10011110100", "10011110010", "11110100100", "11110010100", "11110010010", "11011011110", "11011110110", "11110110110", "10101111000", "10100011110", "10001011110", "10111101000", "10111100010", "11110101000", "11110100010", "10111011110", "10111101110", "11101011110", "11110101110", "11010000100", "11010010000", "11010011100"];
var C128_STOP = "1100011101011";
var EAN_A = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"];
var EAN_B = ["0100111", "0110011", "0011011", "0100001", "0011101", "0111001", "0000101", "0010001", "0001001", "0010111"];
var EAN_C = ["1110010", "1100110", "1101100", "1000010", "1011100", "1001110", "1010000", "1000100", "1001000", "1110100"];
var EAN_PARITY = ["AAAAAA", "AABABB", "AABBAB", "AABBBA", "ABAABB", "ABBAAB", "ABBBAA", "ABABAB", "ABABBA", "ABBABA"];
var EAN_EDGE = "101", EAN_MIDDLE = "01010";
var QR_RS = {"L": [[[26, 19]], [[44, 34]], [[70, 55]], [[100, 80]], [[134, 108]], [[86, 68], [86, 68]], [[98, 78], [98, 78]], [[121, 97], [121, 97]], [[146, 116], [146, 116]], [[86, 68], [86, 68], [87, 69], [87, 69]], [[101, 81], [101, 81], [101, 81], [101, 81]], [[116, 92], [116, 92], [117, 93], [117, 93]], [[133, 107], [133, 107], [133, 107], [133, 107]], [[145, 115], [145, 115], [145, 115], [146, 116]], [[109, 87], [109, 87], [109, 87], [109, 87], [109, 87], [110, 88]]], "M": [[[26, 16]], [[44, 28]], [[70, 44]], [[50, 32], [50, 32]], [[67, 43], [67, 43]], [[43, 27], [43, 27], [43, 27], [43, 27]], [[49, 31], [49, 31], [49, 31], [49, 31]], [[60, 38], [60, 38], [61, 39], [61, 39]], [[58, 36], [58, 36], [58, 36], [59, 37], [59, 37]], [[69, 43], [69, 43], [69, 43], [69, 43], [70, 44]], [[80, 50], [81, 51], [81, 51], [81, 51], [81, 51]], [[58, 36], [58, 36], [58, 36], [58, 36], [58, 36], [58, 36], [59, 37], [59, 37]], [[59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [60, 38]], [[64, 40], [64, 40], [64, 40], [64, 40], [65, 41], [65, 41], [65, 41], [65, 41], [65, 41]], [[65, 41], [65, 41], [65, 41], [65, 41], [65, 41], [66, 42], [66, 42], [66, 42], [66, 42], [66, 42]]], "Q": [[[26, 13]], [[44, 22]], [[35, 17], [35, 17]], [[50, 24], [50, 24]], [[33, 15], [33, 15], [34, 16], [34, 16]], [[43, 19], [43, 19], [43, 19], [43, 19]], [[32, 14], [32, 14], [33, 15], [33, 15], [33, 15], [33, 15]], [[40, 18], [40, 18], [40, 18], [40, 18], [41, 19], [41, 19]], [[36, 16], [36, 16], [36, 16], [36, 16], [37, 17], [37, 17], [37, 17], [37, 17]], [[43, 19], [43, 19], [43, 19], [43, 19], [43, 19], [43, 19], [44, 20], [44, 20]], [[50, 22], [50, 22], [50, 22], [50, 22], [51, 23], [51, 23], [51, 23], [51, 23]], [[46, 20], [46, 20], [46, 20], [46, 20], [47, 21], [47, 21], [47, 21], [47, 21], [47, 21], [47, 21]], [[44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [45, 21], [45, 21], [45, 21], [45, 21]], [[36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [37, 17], [37, 17], [37, 17], [37, 17], [37, 17]], [[54, 24], [54, 24], [54, 24], [54, 24], [54, 24], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25]]]};
var QR_ALIGN = [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70]];
var QR_MAXV = 15;

/* ==========================================================================
   Earlsmere label designer — barcode + QR encoders (no dependencies)
   Requires the generated tables in tables.js:
     C128_CODES, C128_STOP, EAN_A, EAN_B, EAN_C, EAN_PARITY, EAN_EDGE,
     EAN_MIDDLE, QR_RS, QR_ALIGN, QR_MAXV
   ========================================================================== */

/* ---------------------------------------------------------------- Code 128 */
function code128Bits(raw) {
  var data = String(raw == null ? '' : raw);
  // Keep only the printable ASCII range Code 128 set B covers.
  var text = '';
  for (var i = 0; i < data.length; i++) {
    var c = data.charCodeAt(i);
    if (c >= 32 && c <= 126) text += data[i];
  }
  if (!text) return null;

  var allDigits = /^\d+$/.test(text);
  var useC = allDigits && text.length % 2 === 0 && text.length >= 4;
  var start = useC ? 105 : 104;
  var values = [];

  if (useC) {
    for (var j = 0; j < text.length; j += 2) values.push(parseInt(text.substr(j, 2), 10));
  } else {
    for (var k = 0; k < text.length; k++) values.push(text.charCodeAt(k) - 32);
  }

  var sum = start;
  for (var m = 0; m < values.length; m++) sum += (m + 1) * values[m];
  var check = sum % 103;

  var bits = C128_CODES[start];
  for (var n = 0; n < values.length; n++) bits += C128_CODES[values[n]];
  bits += C128_CODES[check];
  bits += C128_STOP;
  return { bits: bits, text: text, symbology: 'Code 128' };
}

/* ----------------------------------------------------------------- EAN-13 */
function ean13CheckDigit(twelve) {
  var sum = 0;
  for (var i = 0; i < 12; i++) sum += (i % 2 === 0 ? 1 : 3) * parseInt(twelve[i], 10);
  return (10 - (sum % 10)) % 10;
}

function ean13Bits(raw) {
  var digits = String(raw == null ? '' : raw).replace(/\D/g, '');
  if (digits.length === 12) digits += String(ean13CheckDigit(digits));
  if (digits.length !== 13) return null;
  if (ean13CheckDigit(digits.slice(0, 12)) !== parseInt(digits[12], 10)) {
    // Correct an invalid check digit rather than refusing to draw.
    digits = digits.slice(0, 12) + String(ean13CheckDigit(digits.slice(0, 12)));
  }

  var parity = EAN_PARITY[parseInt(digits[0], 10)];
  var bits = EAN_EDGE;
  for (var i = 1; i <= 6; i++) {
    var d = parseInt(digits[i], 10);
    bits += (parity[i - 1] === 'A' ? EAN_A : EAN_B)[d];
  }
  bits += EAN_MIDDLE;
  for (var j = 7; j <= 12; j++) bits += EAN_C[parseInt(digits[j], 10)];
  bits += EAN_EDGE;
  return { bits: bits, text: digits, symbology: 'EAN-13', human: digits };
}

function barcodeBits(symbology, value) {
  return symbology === 'ean13' ? ean13Bits(value) : code128Bits(value);
}

/* --------------------------------------------------------------- QR codes */
/* Galois field GF(256), primitive polynomial 0x11D. */
var QR_EXP = new Array(512);
var QR_LOG = new Array(256);
(function buildGaloisField() {
  var x = 1;
  for (var i = 0; i < 255; i++) {
    QR_EXP[i] = x;
    QR_LOG[x] = i;
    x <<= 1;
    if (x & 0x100) x ^= 0x11d;
  }
  for (var j = 255; j < 512; j++) QR_EXP[j] = QR_EXP[j - 255];
})();

function gfMul(a, b) {
  if (a === 0 || b === 0) return 0;
  return QR_EXP[QR_LOG[a] + QR_LOG[b]];
}

function rsGenerator(degree) {
  var poly = [1];
  for (var i = 0; i < degree; i++) {
    var next = new Array(poly.length + 1).fill(0);
    for (var j = 0; j < poly.length; j++) {
      next[j] ^= poly[j];                        // multiply by x
      next[j + 1] ^= gfMul(poly[j], QR_EXP[i]);  // multiply by the root
    }
    poly = next;
  }
  return poly;
}

function rsEncode(data, ecCount) {
  var gen = rsGenerator(ecCount);
  var res = new Array(ecCount).fill(0);
  for (var i = 0; i < data.length; i++) {
    var factor = data[i] ^ res[0];
    res.shift();
    res.push(0);
    if (factor !== 0) {
      for (var j = 0; j < ecCount; j++) res[j] ^= gfMul(gen[j + 1], factor);
    }
  }
  return res;
}

var QR_REMAINDER = [0, 7, 7, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 3, 3];
var QR_EC_BITS = { L: 1, M: 0, Q: 3, H: 2 };

function qrUtf8Bytes(str) {
  var out = [];
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    if (c < 0x80) out.push(c);
    else if (c < 0x800) out.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f));
    else if (c >= 0xd800 && c <= 0xdbff && i + 1 < str.length) {
      var cp = 0x10000 + ((c - 0xd800) << 10) + (str.charCodeAt(++i) - 0xdc00);
      out.push(0xf0 | (cp >> 18), 0x80 | ((cp >> 12) & 0x3f), 0x80 | ((cp >> 6) & 0x3f), 0x80 | (cp & 0x3f));
    } else out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
  }
  return out;
}

function qrBchFormat(value) {
  var d = value << 10;
  for (var i = 14; i >= 10; i--) if (d & (1 << i)) d ^= 0x537 << (i - 10);
  return ((value << 10) | d) ^ 0x5412;
}

function qrBchVersion(version) {
  var d = version << 12;
  for (var i = 17; i >= 12; i--) if (d & (1 << i)) d ^= 0x1f25 << (i - 12);
  return (version << 12) | d;
}

function qrCapacityBytes(version, level) {
  var blocks = QR_RS[level][version - 1];
  var total = 0;
  for (var i = 0; i < blocks.length; i++) total += blocks[i][1];
  var countBits = version < 10 ? 8 : 16;
  var overhead = Math.ceil((4 + countBits) / 8);
  return total - overhead;
}

/** Returns { size, modules: [[bool,...],...], version, level } or null. */
function qrEncode(text, level) {
  var lvl = QR_RS[level] ? level : 'M';
  var bytes = qrUtf8Bytes(String(text == null ? '' : text));
  if (!bytes.length) return null;

  var version = 0;
  for (var v = 1; v <= QR_MAXV; v++) {
    if (bytes.length <= qrCapacityBytes(v, lvl)) { version = v; break; }
  }
  if (!version) return null;

  /* --- bit stream --- */
  var bits = [];
  function push(value, length) {
    for (var i = length - 1; i >= 0; i--) bits.push((value >> i) & 1);
  }
  push(4, 4);                                   // byte mode
  push(bytes.length, version < 10 ? 8 : 16);    // character count
  for (var b = 0; b < bytes.length; b++) push(bytes[b], 8);

  var blocks = QR_RS[lvl][version - 1];
  var dataBytes = 0, totalBytes = 0;
  for (var i0 = 0; i0 < blocks.length; i0++) { totalBytes += blocks[i0][0]; dataBytes += blocks[i0][1]; }

  var capacityBits = dataBytes * 8;
  for (var t = 0; t < 4 && bits.length < capacityBits; t++) bits.push(0);
  while (bits.length % 8 !== 0) bits.push(0);
  var pads = [0xec, 0x11], p = 0;
  while (bits.length < capacityBits) { push(pads[p++ % 2], 8); }

  var codewords = [];
  for (var c = 0; c < bits.length; c += 8) {
    var byte = 0;
    for (var k = 0; k < 8; k++) byte = (byte << 1) | bits[c + k];
    codewords.push(byte);
  }

  /* --- split into blocks, add error correction, interleave --- */
  var dataBlocks = [], ecBlocks = [], offset = 0;
  for (var bi = 0; bi < blocks.length; bi++) {
    var dc = blocks[bi][1];
    var ecCount = blocks[bi][0] - dc;
    var chunk = codewords.slice(offset, offset + dc);
    offset += dc;
    dataBlocks.push(chunk);
    ecBlocks.push(rsEncode(chunk, ecCount));
  }
  var interleaved = [];
  var maxData = Math.max.apply(null, dataBlocks.map(function (x) { return x.length; }));
  for (var d1 = 0; d1 < maxData; d1++) {
    for (var d2 = 0; d2 < dataBlocks.length; d2++) if (d1 < dataBlocks[d2].length) interleaved.push(dataBlocks[d2][d1]);
  }
  var maxEc = Math.max.apply(null, ecBlocks.map(function (x) { return x.length; }));
  for (var e1 = 0; e1 < maxEc; e1++) {
    for (var e2 = 0; e2 < ecBlocks.length; e2++) if (e1 < ecBlocks[e2].length) interleaved.push(ecBlocks[e2][e1]);
  }

  var finalBits = [];
  for (var f = 0; f < interleaved.length; f++) {
    for (var fb = 7; fb >= 0; fb--) finalBits.push((interleaved[f] >> fb) & 1);
  }
  for (var r = 0; r < QR_REMAINDER[version - 1]; r++) finalBits.push(0);

  /* --- module matrix --- */
  var size = version * 4 + 17;
  var mods = [], reserved = [];
  for (var y = 0; y < size; y++) {
    mods.push(new Array(size).fill(0));
    reserved.push(new Array(size).fill(false));
  }

  function setFn(x, y, value) {
    if (x < 0 || y < 0 || x >= size || y >= size) return;
    mods[y][x] = value ? 1 : 0;
    reserved[y][x] = true;
  }

  function placeFinder(cx, cy) {
    for (var dy = -1; dy <= 7; dy++) {
      for (var dx = -1; dx <= 7; dx++) {
        var xx = cx + dx, yy = cy + dy;
        if (xx < 0 || yy < 0 || xx >= size || yy >= size) continue;
        var inRing = (dx >= 0 && dx <= 6 && (dy === 0 || dy === 6)) ||
                     (dy >= 0 && dy <= 6 && (dx === 0 || dx === 6));
        var inCore = dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4;
        setFn(xx, yy, inRing || inCore);
      }
    }
  }
  placeFinder(0, 0);
  placeFinder(size - 7, 0);
  placeFinder(0, size - 7);

  for (var tp = 8; tp < size - 8; tp++) {
    setFn(tp, 6, tp % 2 === 0);
    setFn(6, tp, tp % 2 === 0);
  }

  var aligns = QR_ALIGN[version - 1];
  for (var a1 = 0; a1 < aligns.length; a1++) {
    for (var a2 = 0; a2 < aligns.length; a2++) {
      var ax = aligns[a1], ay = aligns[a2];
      if ((ax <= 8 && ay <= 8) || (ax <= 8 && ay >= size - 9) || (ax >= size - 9 && ay <= 8)) continue;
      for (var my = -2; my <= 2; my++) {
        for (var mx = -2; mx <= 2; mx++) {
          var ring = Math.max(Math.abs(mx), Math.abs(my));
          setFn(ax + mx, ay + my, ring !== 1);
        }
      }
    }
  }

  setFn(8, size - 8, true); // dark module

  // reserve format information areas
  for (var fi = 0; fi < 9; fi++) {
    if (!reserved[fi][8]) setFn(8, fi, false);
    if (!reserved[8][fi]) setFn(fi, 8, false);
  }
  for (var fj = 0; fj < 8; fj++) {
    if (!reserved[8][size - 1 - fj]) setFn(size - 1 - fj, 8, false);
    if (!reserved[size - 1 - fj][8]) setFn(8, size - 1 - fj, false);
  }

  // reserve version information areas (version 7+)
  if (version >= 7) {
    for (var vi = 0; vi < 18; vi++) {
      var vr = Math.floor(vi / 3), vc = vi % 3;
      setFn(vr, size - 11 + vc, false);
      setFn(size - 11 + vc, vr, false);
    }
  }

  /* --- zig-zag data placement --- */
  var bitIndex = 0, upward = true;
  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col = 5; // skip the vertical timing column
    for (var row = 0; row < size; row++) {
      var yPos = upward ? size - 1 - row : row;
      for (var q = 0; q < 2; q++) {
        var xPos = col - q;
        if (reserved[yPos][xPos]) continue;
        mods[yPos][xPos] = bitIndex < finalBits.length ? finalBits[bitIndex] : 0;
        bitIndex++;
      }
    }
    upward = !upward;
  }

  /* --- masking --- */
  function maskFn(m, x, y) {
    switch (m) {
      case 0: return (x + y) % 2 === 0;
      case 1: return y % 2 === 0;
      case 2: return x % 3 === 0;
      case 3: return (x + y) % 3 === 0;
      case 4: return (Math.floor(y / 2) + Math.floor(x / 3)) % 2 === 0;
      case 5: return ((x * y) % 2) + ((x * y) % 3) === 0;
      case 6: return (((x * y) % 2) + ((x * y) % 3)) % 2 === 0;
      default: return (((x + y) % 2) + ((x * y) % 3)) % 2 === 0;
    }
  }

  function penalty(grid) {
    var score = 0, i, j, run, dark = 0;
    // rule 1: runs of five or more
    for (i = 0; i < size; i++) {
      run = 1;
      for (j = 1; j < size; j++) {
        if (grid[i][j] === grid[i][j - 1]) { run++; } else { if (run >= 5) score += run - 2; run = 1; }
      }
      if (run >= 5) score += run - 2;
      run = 1;
      for (j = 1; j < size; j++) {
        if (grid[j][i] === grid[j - 1][i]) { run++; } else { if (run >= 5) score += run - 2; run = 1; }
      }
      if (run >= 5) score += run - 2;
    }
    // rule 2: 2x2 blocks
    for (i = 0; i < size - 1; i++) {
      for (j = 0; j < size - 1; j++) {
        var v = grid[i][j];
        if (v === grid[i][j + 1] && v === grid[i + 1][j] && v === grid[i + 1][j + 1]) score += 3;
      }
    }
    // rule 3: finder-like patterns
    var pat1 = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0];
    var pat2 = [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1];
    function matches(get, at, pat) {
      for (var z = 0; z < 11; z++) if (get(at + z) !== pat[z]) return false;
      return true;
    }
    for (i = 0; i < size; i++) {
      for (j = 0; j <= size - 11; j++) {
        var rowGet = (function (rr) { return function (cc) { return grid[rr][cc]; }; })(i);
        var colGet = (function (cc) { return function (rr) { return grid[rr][cc]; }; })(i);
        if (matches(rowGet, j, pat1) || matches(rowGet, j, pat2)) score += 40;
        if (matches(colGet, j, pat1) || matches(colGet, j, pat2)) score += 40;
      }
    }
    // rule 4: dark/light balance
    for (i = 0; i < size; i++) for (j = 0; j < size; j++) if (grid[i][j]) dark++;
    var pct = (dark * 100) / (size * size);
    score += Math.floor(Math.abs(pct - 50) / 5) * 10;
    return score;
  }

  var best = null, bestScore = Infinity, bestMask = 0;
  for (var mk = 0; mk < 8; mk++) {
    var grid = [];
    for (var gy = 0; gy < size; gy++) {
      grid.push(mods[gy].slice());
      for (var gx = 0; gx < size; gx++) {
        if (!reserved[gy][gx] && maskFn(mk, gx, gy)) grid[gy][gx] ^= 1;
      }
    }
    // write format information for this mask before scoring
    var fmt = qrBchFormat((QR_EC_BITS[lvl] << 3) | mk);
    for (var fb2 = 0; fb2 < 15; fb2++) {
      var bit = (fmt >> fb2) & 1;
      if (fb2 < 6) grid[fb2][8] = bit;
      else if (fb2 === 6) grid[7][8] = bit;
      else if (fb2 === 7) grid[8][8] = bit;
      else if (fb2 === 8) grid[8][7] = bit;
      else grid[8][14 - fb2] = bit;

      if (fb2 < 8) grid[8][size - 1 - fb2] = bit;
      else grid[size - 15 + fb2][8] = bit;
    }
    grid[size - 8][8] = 1; // dark module

    if (version >= 7) {
      var vinfo = qrBchVersion(version);
      for (var vb = 0; vb < 18; vb++) {
        var vbit = (vinfo >> vb) & 1;
        grid[Math.floor(vb / 3)][size - 11 + (vb % 3)] = vbit;
        grid[size - 11 + (vb % 3)][Math.floor(vb / 3)] = vbit;
      }
    }

    var sc = penalty(grid);
    if (sc < bestScore) { bestScore = sc; best = grid; bestMask = mk; }
  }

  return { size: size, modules: best, version: version, level: lvl, mask: bestMask };
}



window.__ELD_CODES = { barcodeBits: barcodeBits, qrEncode: qrEncode, ean13CheckDigit: ean13CheckDigit };
})();
var barcodeBits = window.__ELD_CODES.barcodeBits,
    qrEncode = window.__ELD_CODES.qrEncode,
    ean13CheckDigit = window.__ELD_CODES.ean13CheckDigit;
/* ==========================================================================
   Earlsmere "Design Your Own Tag"
   Laser-etched TPU tags: Handy Tag 54x74 and Tall Tag 60x223, six body
   colours, one or two printed sides, priced per tag and added to the basket.
   Vanilla JS, no dependencies, everything scoped to .eld.
   Depends on codes.js for barcodeBits() and qrEncode().
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.ELD_CONFIG || {};
  var IS_SHOPIFY = !!(window.Shopify && window.Shopify.routes) || CFG.forceShopify === true;
  var SHOW_BOTH = CFG.showBothFaces === true;   // side-by-side faces; off = Front/Back toggle

  /* --------------------------------------------------------- tag constants */
  /* `hole` is the punched fixing hole, centred, `top` mm down from the top edge
     and `d` mm across. Both come from theme settings so the position can be
     trued up against a real tag without touching code. */
  var TAGS = {
    handy: {
      key: 'handy', name: 'Handy Tag', w: 54, h: 74,
      shoulder: 30, apexR: 7, cornerR: 6,
      hole: { top: 5.5, d: 4.7, boss: 13 },
      print: { x: 3, y: 33, w: 48, h: 38 },
      blurb: 'Our most popular tag. Tough, flexible TPU that shrugs off oil, solvents and temperature swings.'
    },
    tall: {
      key: 'tall', name: 'Tall Tag', w: 60, h: 223,
      headW: 28, headH: 11, headR: 5, stemW: 7, stemTop: 9,
      faceTop: 155, faceR: 16,
      hole: null,
      slots: [{ y: 157, w: 7, h: 1.8 }, { y: 216, w: 7, h: 1.8 }],
      print: { x: 4, y: 162, w: 52, h: 50 },
      blurb: 'A long strap with a wide face at the bottom — same TPU, same laser-etched print.'
    },
    /* Site Tag — the shorter, cheaper flag. Same family of shape as the Handy
       Tag, a moulded boss instead of a punched hole, and only five colours.
       Sizes are in millimetres: change w/h here and the preview, the guides and
       the 300 dpi proof all follow. */
    site: {
      key: 'site', name: 'Site Tag', w: 55, h: 60,
      shoulder: 25, apexR: 9.5, cornerR: 5,
      hole: { top: 10, d: 5, boss: 13 },
      print: { x: 3, y: 28, w: 49, h: 29 },
      colours: ['green', 'orange', 'blue', 'yellow', 'white'],
      blurb: 'Shorter, cheaper, five colours. For the jobs where the tag does not need to outlive the job.'
    },
    /* RFID Rigid Tag (HF) — a plain rounded rectangle with an ICODE SLIX chip
       inside. Moulded in TPU with Laserflare, so it is made to be laser marked.
       `shape: 'rounded'` picks the plain-rectangle branch in labelPath(). */
    rfid: {
      key: 'rfid', name: 'RFID Rigid Tag', w: 63, h: 73,
      /* Not the Handy Tag's straight-sided peak: this one is a rounded body
         that sweeps in on a concave cove to a round cap, with a black moulded
         boss set into it. Measured off a real tag. */
      shape: 'necked',
      bodyTop: 34, capR: 11, cornerR: 8, topR: 3,
      hole: { top: 11, d: 7, boss: 14, colour: '#141414' },
      print: { x: 4, y: 38, w: 55, h: 31 },
      colours: ['orange', 'yellow', 'red', 'green'],
      blurb: 'HF 13.56 MHz ICODE SLIX chip inside, TPU with Laserflare. Reads with the Toolminder app.'
    }
  };

  /* The laser marks the same dark tone whatever the tag colour, so `etch` is
     black across the board — the body colours are what change. */
  var ETCH = '#1a1a1a';
  var COLOURS = [
    { key: 'red',    name: 'Red',    hex: '#c1272d' },
    { key: 'green',  name: 'Green',  hex: '#34a24a' },
    { key: 'orange', name: 'Orange', hex: '#e2711d' },
    { key: 'blue',   name: 'Blue',   hex: '#1e9cd7' },
    { key: 'white',  name: 'White',  hex: '#f4f4f2' },
    { key: 'yellow', name: 'Yellow', hex: '#f2c200' }
  ];

  /* Prices ex VAT, mirroring the Bespoke Tag variants. Both live in theme
     settings, so a price change is a theme edit rather than a code change. */
  var PRICES = {
    handy: { single: Number(CFG.priceHandySingle) || 0.95, double: Number(CFG.priceHandyDouble) || 1.35 },
    tall:  { single: Number(CFG.priceTallSingle)  || 1.45, double: Number(CFG.priceTallDouble)  || 1.95 },
    site:  { single: Number(CFG.priceSiteSingle)  || 0.35, double: Number(CFG.priceSiteDouble)  || 0.50 },
    rfid:  { single: Number(CFG.priceRfidSingle)  || 3.01, double: Number(CFG.priceRfidDouble)  || 3.55 }
  };
  var VARIANTS = {
    handy: { single: String(CFG.variantHandySingle || ''), double: String(CFG.variantHandyDouble || '') },
    tall:  { single: String(CFG.variantTallSingle  || ''), double: String(CFG.variantTallDouble  || '') },
    site:  { single: String(CFG.variantSiteSingle  || ''), double: String(CFG.variantSiteDouble  || '') },
    rfid:  { single: String(CFG.variantRfidSingle  || ''), double: String(CFG.variantRfidDouble  || '') }
  };

  var QTY_CHIPS = [10, 25, 50, 100, 250, 500];

  var LABELS = {
    sides: { single: 'Single sided', double: 'Double sided' },
    side:  { front: 'Front', back: 'Back' }
  };

  var SAFE_MM = 2;
  var PROOF_DPI = 300;
  var SENT_KEY = 'eld:pending-tag';

  /* ------------------------------------------------------------------ state */
  var uid = 0;
  var state = {
    tag: 'handy', colour: 'yellow', sides: 'single', side: 'front',
    stored: { front: [], back: [] },
    elements: [],
    quantity: 50,
    reference: ''
  };
  state.elements = state.stored.front;
  var selectedId = null;
  var zoom = 0;
  var showGuides = true;
  var root, canvas, ctx, canvases = {};

  function tagDef() { return TAGS[state.tag] || TAGS.handy; }

  /* Not every tag is moulded in every colour, so the swatches follow the tag
     rather than the other way round. No `colours` list means all of them. */
  function tagColours() {
    var allow = tagDef().colours;
    if (!allow) return COLOURS;
    return COLOURS.filter(function (c) { return allow.indexOf(c.key) !== -1; });
  }
  function colourDef() {
    for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].key === state.colour) return COLOURS[i];
    return COLOURS[5];
  }
  function etchColour() { return ETCH; }
  function unitPrice() { return (PRICES[state.tag] || PRICES.handy)[state.sides]; }
  function variantId() { return (VARIANTS[state.tag] || {})[state.sides] || ''; }
  function fmtMoney(n) { return '£' + Number(n).toFixed(2); }
  function sideList() { return state.sides === 'double' ? ['front', 'back'] : ['front']; }

  /* `sideList` is what the tag HAS. `visibleSides` is what is on screen: by
     default one face at a time, swapped with the Front/Back toggle. Ticking
     "Show both faces" in the theme settings puts them side by side instead.
     Everything that counts, prices or saves the design uses sideList, so the
     back is never lost just because it isn't being looked at. */
  function visibleSides() {
    return (SHOW_BOTH && state.sides === 'double') ? ['front', 'back'] : [state.side];
  }
  function countBoth(fn) {
    sideList().forEach(function (side) {
      (side === state.side ? state.elements : state.stored[side]).forEach(fn);
    });
  }

  /* ----------------------------------------------------------------- helpers */
  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v, min, max, fallback) {
    var n = parseFloat(v);
    if (!isFinite(n)) return fallback;
    return Math.min(max, Math.max(min, n));
  }
  function round1(n) { return parseFloat(Number(n).toFixed(1)); }
  function fmtMm(n) { return String(parseFloat(Number(n).toFixed(1))); }
  function fmtInt(n) { return Number(n).toLocaleString('en-GB'); }

  /* ------------------------------------------------------------- geometry */
  function labelW() { return tagDef().w; }
  function labelH() { return tagDef().h; }
  function isRound() { return false; }
  function cornerRadius() { return tagDef().radius; }

  function holeGeom() {
    var t = tagDef();
    if (!t.hole) return null;
    return { cx: t.w / 2, cy: t.hole.top, r: t.hole.d / 2 };
  }

  function runInfo() {
    var qty = Math.max(1, Math.round(state.quantity || 1));
    return { qty: qty, unit: unitPrice(), total: qty * unitPrice() };
  }

  function textLines(e, pxPerMm, c) {
    c.font = fontString(e, pxPerMm);
    var maxPx = (e.w || labelW()) * pxPerMm;
    var out = [];
    String(e.text || '').split('\n').forEach(function (para) {
      var words = para.split(/\s+/).filter(Boolean);
      if (!words.length) { out.push(''); return; }
      var line = words[0];
      for (var i = 1; i < words.length; i++) {
        if (c.measureText(line + ' ' + words[i]).width <= maxPx) line += ' ' + words[i];
        else { out.push(line); line = words[i]; }
      }
      out.push(line);
    });
    return out;
  }

  function fontString(e, pxPerMm) {
    var style = e.italic ? 'italic ' : '';
    return style + (e.weight || 600) + ' ' + (e.size * pxPerMm) + 'px ' + (CFG.canvasFont || '"Inter", Helvetica, Arial, sans-serif');
  }

  function bounds(e) {
    switch (e.type) {
      case 'text':
      case 'serial': {
        var pxPerMm = 4;
        ctx.save();
        var lines = e.type === 'serial' ? [serialSample(e)] : textLines(e, pxPerMm, ctx);
        ctx.font = fontString(e, pxPerMm);
        var wMax = 0;
        lines.forEach(function (l) { wMax = Math.max(wMax, ctx.measureText(l).width / pxPerMm); });
        ctx.restore();
        var lh = e.size * (e.lineHeight || 1.22);
        return { x: e.x, y: e.y, w: Math.max(wMax, 1), h: Math.max(lines.length * lh, e.size) };
      }
      case 'qr': return { x: e.x, y: e.y, w: e.size, h: e.size };
      case 'line': return { x: e.x, y: e.y - (e.thickness / 2), w: e.w, h: Math.max(e.thickness, 1) };
      default: return { x: e.x, y: e.y, w: e.w, h: e.h };
    }
  }

  function serialSample(e) {
    var n = String(e.start == null ? 1 : e.start);
    while (n.length < (e.digits || 5)) n = '0' + n;
    return (e.prefix || '') + n + (e.suffix || '');
  }

  /* ------------------------------------------------------------- rendering */
  function roundRectPath(c, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, Math.min(w, h) / 2));
    c.beginPath();
    c.moveTo(x + r, y);
    c.lineTo(x + w - r, y);
    c.arcTo(x + w, y, x + w, y + r, r);
    c.lineTo(x + w, y + h - r);
    c.arcTo(x + w, y + h, x + w - r, y + h, r);
    c.lineTo(x + r, y + h);
    c.arcTo(x, y + h, x, y + h - r, r);
    c.lineTo(x, y + r);
    c.arcTo(x, y, x + r, y, r);
    c.closePath();
  }

  /* The real tag outlines, drawn to scale in mm then scaled by pxPerMm, so the
     customer sees the shape they will actually receive. */
  function labelPath(c, pxPerMm) {
    var t = tagDef(), k = pxPerMm;
    c.beginPath();
    if (t.key === 'tall') {
      var cx = t.w / 2, hw = t.headW / 2, sw = t.stemW / 2;
      c.moveTo((cx - hw + t.headR) * k, 0);
      c.lineTo((cx + hw - t.headR) * k, 0);
      c.quadraticCurveTo((cx + hw) * k, 0, (cx + hw) * k, t.headR * k);
      c.quadraticCurveTo((cx + hw) * k, t.headH * k, (cx + sw) * k, t.stemTop * k);
      c.lineTo((cx + sw) * k, t.faceTop * k);
      c.quadraticCurveTo(t.w * k, (t.faceTop + 3) * k, t.w * k, (t.faceTop + t.faceR + 3) * k);
      c.lineTo(t.w * k, (t.h - t.faceR) * k);
      c.quadraticCurveTo(t.w * k, t.h * k, (t.w - t.faceR) * k, t.h * k);
      c.lineTo(t.faceR * k, t.h * k);
      c.quadraticCurveTo(0, t.h * k, 0, (t.h - t.faceR) * k);
      c.lineTo(0, (t.faceTop + t.faceR + 3) * k);
      c.quadraticCurveTo(0, (t.faceTop + 3) * k, (cx - sw) * k, t.faceTop * k);
      c.lineTo((cx - sw) * k, t.stemTop * k);
      c.quadraticCurveTo((cx - hw) * k, t.headH * k, (cx - hw) * k, t.headR * k);
      c.quadraticCurveTo((cx - hw) * k, 0, (cx - hw + t.headR) * k, 0);
      c.closePath();
      return;
    }
    if (t.shape === 'necked') {
      var nx = t.w / 2, R = t.capR, bt = t.bodyTop, cr = t.cornerR, tr = t.topR;
      c.moveTo(cr * k, t.h * k);
      c.lineTo((t.w - cr) * k, t.h * k);
      c.quadraticCurveTo(t.w * k, t.h * k, t.w * k, (t.h - cr) * k);
      c.lineTo(t.w * k, (bt + tr) * k);
      c.quadraticCurveTo(t.w * k, bt * k, (t.w - tr) * k, bt * k);
      /* the cove — nearly horizontal where it leaves the body, nearly vertical
         where it meets the cap, which is what makes it read as a moulded neck */
      c.bezierCurveTo((t.w - 3) * k, bt * k, (nx + R + 1) * k, (R + 9) * k, (nx + R) * k, R * k);
      c.arc(nx * k, R * k, R * k, 0, Math.PI, true);
      c.bezierCurveTo((nx - R - 1) * k, (R + 9) * k, 3 * k, bt * k, tr * k, bt * k);
      c.quadraticCurveTo(0, bt * k, 0, (bt + tr) * k);
      c.lineTo(0, (t.h - cr) * k);
      c.quadraticCurveTo(0, t.h * k, cr * k, t.h * k);
      c.closePath();
      return;
    }
    var c2 = t.w / 2;
    c.moveTo(t.cornerR * k, t.h * k);
    c.lineTo((t.w - t.cornerR) * k, t.h * k);
    c.quadraticCurveTo(t.w * k, t.h * k, t.w * k, (t.h - t.cornerR) * k);
    c.lineTo(t.w * k, t.shoulder * k);
    c.lineTo((c2 + t.apexR * 0.5) * k, (t.apexR * 0.45) * k);
    c.quadraticCurveTo(c2 * k, -0.5 * k, (c2 - t.apexR * 0.5) * k, (t.apexR * 0.45) * k);
    c.lineTo(0, t.shoulder * k);
    c.lineTo(0, (t.h - t.cornerR) * k);
    c.quadraticCurveTo(0, t.h * k, t.cornerR * k, t.h * k);
    c.closePath();
  }

  /* Punched after the body so holes read as holes, not drawn circles. */
  function punchHole(c, pxPerMm) {
    var t = tagDef(), k = pxPerMm, h = holeGeom();
    if (h) {
      c.save();
      c.fillStyle = t.hole.colour || 'rgba(0,0,0,.10)';
      c.beginPath();
      c.arc(h.cx * k, h.cy * k, (t.hole.boss / 2) * k, 0, Math.PI * 2);
      c.fill();
      c.restore();
    }
    c.save();
    c.globalCompositeOperation = 'destination-out';
    if (h) {
      c.beginPath();
      c.arc(h.cx * k, h.cy * k, h.r * k, 0, Math.PI * 2);
      c.fill();
    }
    (t.slots || []).forEach(function (sl) {
      c.beginPath();
      c.ellipse((t.w / 2) * k, sl.y * k, (sl.w / 2) * k, (sl.h / 2) * k, 0, 0, Math.PI * 2);
      c.fill();
    });
    c.restore();
  }


  function drawBarcode(c, e, pxPerMm) {
    var res = barcodeBits(e.symbology, e.value);
    var x = e.x * pxPerMm, y = e.y * pxPerMm, w = e.w * pxPerMm, h = e.h * pxPerMm;
    if (!res) {
      c.save();
      c.fillStyle = 'rgba(180,105,14,.12)';
      c.fillRect(x, y, w, h);
      c.strokeStyle = '#b4690e'; c.lineWidth = Math.max(1, pxPerMm * 0.2);
      c.setLineDash([pxPerMm * 1.2, pxPerMm * 1.2]);
      c.strokeRect(x, y, w, h);
      c.setLineDash([]);
      c.fillStyle = '#b4690e';
      c.font = (Math.max(6, h * 0.22)) + 'px ' + (CFG.canvasFont || 'Helvetica, Arial, sans-serif');
      c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText('Barcode value not valid', x + w / 2, y + h / 2);
      c.restore();
      return;
    }
    var bits = res.bits;
    var textH = e.showText ? h * 0.2 : 0;
    var barsH = h - textH;
    var unit = w / bits.length;
    c.save();
    c.fillStyle = etchColour();
    for (var i = 0; i < bits.length; i++) {
      if (bits[i] === '1') c.fillRect(x + i * unit, y, Math.ceil(unit), barsH);
    }
    if (e.showText) {
      c.fillStyle = etchColour();
      c.font = '600 ' + (textH * 0.86) + 'px ' + (CFG.canvasFont || 'Helvetica, Arial, sans-serif');
      c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      c.fillText(res.human || res.text, x + w / 2, y + h - textH * 0.12);
    }
    c.restore();
  }

  function drawQr(c, e, pxPerMm) {
    var res = qrEncode(e.value, e.ec || 'M');
    var x = e.x * pxPerMm, y = e.y * pxPerMm, size = e.size * pxPerMm;
    c.save();
    if (!res) {
      c.strokeStyle = '#b4690e'; c.lineWidth = Math.max(1, pxPerMm * 0.2);
      c.setLineDash([pxPerMm * 1.2, pxPerMm * 1.2]);
      c.strokeRect(x, y, size, size);
      c.restore();
      return;
    }
    var quiet = 4;
    var n = res.size + quiet * 2;
    var m = size / n;
    c.fillStyle = colourDef().hex;
    c.fillRect(x, y, size, size);
    c.fillStyle = etchColour();
    for (var yy = 0; yy < res.size; yy++) {
      for (var xx = 0; xx < res.size; xx++) {
        if (res.modules[yy][xx]) c.fillRect(x + (xx + quiet) * m, y + (yy + quiet) * m, Math.ceil(m), Math.ceil(m));
      }
    }
    c.restore();
  }

  function drawElement(c, e, pxPerMm) {
    switch (e.type) {
      case 'box': {
        c.save();
        roundRectPath(c, e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm, (e.radius || 0) * pxPerMm);
        if (e.fill && e.fill !== 'none') { c.fillStyle = etchColour(); c.fill(); }
        if (e.strokeW > 0) { c.strokeStyle = etchColour(); c.lineWidth = e.strokeW * pxPerMm; c.stroke(); }
        c.restore();
        break;
      }
      case 'line': {
        c.save();
        c.strokeStyle = etchColour();
        c.lineWidth = Math.max(0.05, e.thickness) * pxPerMm;
        c.lineCap = 'butt';
        c.beginPath();
        c.moveTo(e.x * pxPerMm, e.y * pxPerMm);
        c.lineTo((e.x + e.w) * pxPerMm, e.y * pxPerMm);
        c.stroke();
        c.restore();
        break;
      }
      case 'image': {
        if (e._img && e._img.complete && e._img.naturalWidth) {
          c.drawImage(etchedImage(e), e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm);
        } else {
          c.save();
          c.fillStyle = 'rgba(12,21,25,.06)';
          c.fillRect(e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm);
          c.restore();
        }
        break;
      }
      case 'barcode': drawBarcode(c, e, pxPerMm); break;
      case 'qr': drawQr(c, e, pxPerMm); break;
      case 'text':
      case 'serial': {
        c.save();
        c.fillStyle = etchColour();
        c.font = fontString(e, pxPerMm);
        c.textBaseline = 'top';
        var lines = e.type === 'serial' ? [serialSample(e)] : textLines(e, pxPerMm, c);
        var lh = e.size * (e.lineHeight || 1.22) * pxPerMm;
        var b = bounds(e);
        lines.forEach(function (line, i) {
          var lx = e.x * pxPerMm;
          if (e.align === 'center') { c.textAlign = 'center'; lx = (e.x + b.w / 2) * pxPerMm; }
          else if (e.align === 'right') { c.textAlign = 'right'; lx = (e.x + b.w) * pxPerMm; }
          else c.textAlign = 'left';
          c.fillText(line, lx, e.y * pxPerMm + i * lh);
        });
        c.restore();
        break;
      }
    }
  }

  /* A laser marks one tone into the plastic, so artwork is redrawn as a single
     colour carrying the original's luminance in its alpha. Cached per element
     and etch colour, since it is redrawn on every frame. */
  function etchedImage(e) {
    var img = e._img;
    var key = etchColour() + ':' + (img.naturalWidth || 0) + 'x' + (img.naturalHeight || 0);
    if (e._etch && e._etchKey === key) return e._etch;
    var w = Math.min(img.naturalWidth || 1, 900);
    var h = Math.max(1, Math.round((img.naturalHeight || 1) * (w / (img.naturalWidth || 1))));
    var c = document.createElement('canvas');
    c.width = Math.max(1, w); c.height = h;
    var cc = c.getContext('2d');
    cc.drawImage(img, 0, 0, c.width, c.height);
    try {
      var d = cc.getImageData(0, 0, c.width, c.height), px = d.data;
      var light = false;   // always a dark mark
      for (var i = 0; i < px.length; i += 4) {
        var lum = (px[i] * 0.299 + px[i + 1] * 0.587 + px[i + 2] * 0.114) / 255;
        var ink = light ? lum : 1 - lum;
        px[i] = px[i + 1] = px[i + 2] = light ? 255 : 26;
        px[i + 3] = Math.round(px[i + 3] * Math.min(1, Math.max(0, ink)));
      }
      cc.putImageData(d, 0, 0);
    } catch (err) { /* tainted canvas: leave it as drawn */ }
    e._etch = c; e._etchKey = key;
    return c;
  }

  function renderTo(c, pxPerMm, opts) {
    opts = opts || {};
    var w = labelW() * pxPerMm, h = labelH() * pxPerMm;
    c.clearRect(0, 0, w, h);

    c.save();
    labelPath(c, pxPerMm);
    c.fillStyle = colourDef().hex;
    c.fill();
    c.clip();
    state.elements.forEach(function (e) { drawElement(c, e, pxPerMm); });
    c.restore();

    punchHole(c, pxPerMm);

    c.save();
    labelPath(c, pxPerMm);
    c.strokeStyle = 'rgba(12,21,25,.35)';
    c.lineWidth = Math.max(1, pxPerMm * 0.1);
    c.stroke();
    c.restore();

    if (opts.guides) {
      var box = fitBox();
      c.save();
      c.setLineDash([pxPerMm * 1.6, pxPerMm * 1.4]);
      c.strokeStyle = 'rgba(0,160,223,.85)';
      c.lineWidth = Math.max(1, pxPerMm * 0.09);
      c.strokeRect(box.x * pxPerMm, box.y * pxPerMm, box.w * pxPerMm, box.h * pxPerMm);
      c.restore();
    }

    if (opts.selection && selectedId) {
      var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
      if (sel) {
        var b = bounds(sel);
        c.save();
        c.strokeStyle = '#00A0DF';
        c.lineWidth = 1.5;
        c.setLineDash([4, 3]);
        c.strokeRect(b.x * pxPerMm - 2, b.y * pxPerMm - 2, b.w * pxPerMm + 4, b.h * pxPerMm + 4);
        c.setLineDash([]);
        c.fillStyle = '#00A0DF';
        c.fillRect((b.x + b.w) * pxPerMm - 3, (b.y + b.h) * pxPerMm - 3, 10, 10);
        c.restore();
      }
    }
  }

  function fitScale() {
    var wrap = $('[data-eld-canvaswrap]');
    var faces = visibleSides().length;
    var availW = Math.max(160, (wrap.clientWidth - 56 - (faces - 1) * 30) / faces);
    var availH = Math.max(300, Math.min(600, (window.innerHeight || 900) * 0.62));
    return Math.min(availW / labelW(), availH / labelH());
  }

  function currentScale() { return zoom > 0 ? zoom : fitScale(); }

  /* Paint each visible face. The one being worked on gets the guides and the
     selection handles; the other is shown plain and slightly faded, so a
     double-sided tag reads as two real faces rather than a hidden second page. */
  function drawFace(side) {
    var cv = canvases[side];
    if (!cv) return;
    var pxPerMm = currentScale();
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var cssW = Math.max(1, Math.floor(labelW() * pxPerMm));
    var cssH = Math.max(1, Math.floor(labelH() * pxPerMm));
    cv.style.width = cssW + 'px';
    cv.style.height = cssH + 'px';
    cv.width = Math.round(cssW * dpr);
    cv.height = Math.round(cssH * dpr);
    var c = cv.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);

    var active = side === state.side;
    var mine = active ? state.elements : (state.stored[side] || []);
    var swap = state.elements;
    state.elements = mine;                       // renderTo draws the current side
    renderTo(c, pxPerMm, { guides: active && showGuides, selection: active });
    state.elements = swap;
  }

  function draw() {
    /* Show or hide the second face BEFORE measuring, or the scale is worked out
       against a one-face-wide row and the pair wraps onto two lines. */
    var vis = visibleSides();
    $$('[data-eld-face]').forEach(function (f) {
      var side = f.getAttribute('data-eld-face');
      f.style.display = vis.indexOf(side) === -1 ? 'none' : '';
      f.classList.toggle('is-on', side === state.side);
    });
    /* The caption only earns its place when there are two sides to tell apart. */
    root.classList.toggle('eld--twoside', state.sides === 'double');
    vis.forEach(drawFace);
    var pxPerMm = currentScale();
    $('[data-eld-zoomval]').textContent = zoom > 0 ? Math.round(pxPerMm / (96 / 25.4) * 100) + '%' : 'Fit';
    $('[data-eld-readout]').innerHTML =
      esc(tagDef().name) + ' <span>' + fmtMm(labelW()) + ' &times; ' + fmtMm(labelH()) + '&thinsp;mm &middot; ' +
      esc(colourDef().name) + (state.sides === 'double' ? ' &middot; ' + esc(LABELS.sides[state.sides].toLowerCase()) : '') + '</span>';
  }

  /* ------------------------------------------------------- element factory */
  function makeElement(type, extra) {
    var box = fitBox();                       // everything starts inside the usable area
    var W = box.w, H = box.h;
    var base = { id: 'e' + (++uid), type: type };
    var defaults = {
      text: { text: 'Your text here', x: box.x, y: box.y, w: W, size: Math.max(2.2, Math.min(W * 0.13, H * 0.1)), weight: 700, align: 'left', lineHeight: 1.22 },
      serial: { prefix: 'EM-', start: 1, digits: 5, suffix: '', x: box.x, y: box.y + H * 0.4, size: Math.max(2, Math.min(W * 0.11, H * 0.08)), weight: 700, align: 'left', lineHeight: 1.22 },
      image: { src: '', x: box.x, y: box.y, w: W * 0.6, h: W * 0.6 },
      barcode: { symbology: 'code128', value: 'EARLSMERE-0001', x: box.x, y: box.y + H * 0.7, w: W, h: Math.max(7, H * 0.18), showText: true },
      qr: { value: 'https://earlsmere.co.uk', ec: 'M', x: box.x + W * 0.25, y: box.y + H * 0.35, size: Math.min(W, H) * 0.45 },
      box: { x: box.x, y: box.y, w: W, h: H * 0.3, fill: 'none', strokeW: 0.4, radius: 1 },
      line: { x: box.x, y: box.y + H * 0.5, w: W, thickness: 0.4 }
    }[type];
    var e = Object.assign(base, defaults, extra || {});
    ['x', 'y', 'w', 'h', 'size', 'radius', 'thickness', 'strokeW'].forEach(function (k) {
      if (typeof e[k] === 'number') e[k] = round1(e[k]);
    });
    if (!extra || (extra.x == null && extra.y == null)) {
      var step = Math.min(5, Math.max(1.5, Math.min(W, H) * 0.05));
      var n = state.elements.length % 5;
      e.x = round1(Math.min(e.x + n * step, box.x + Math.max(0, W - 6)));
      e.y = round1(Math.min(e.y + n * step, box.y + Math.max(0, H - 6)));
    }
    state.elements.push(e);
    selectedId = e.id;
    clampElements();
    return e;
  }

  function elementName(e) {
    switch (e.type) {
      case 'text': return (String(e.text || '').split('\n')[0] || 'Text').slice(0, 34);
      case 'serial': return serialSample(e);
      case 'barcode': return (e.symbology === 'ean13' ? 'EAN-13 ' : 'Code 128 ') + (e.value || '');
      case 'qr': return 'QR: ' + String(e.value || '').slice(0, 28);
      case 'image': return 'Logo / artwork';
      case 'box': return 'Box';
      case 'line': return 'Rule';
      default: return e.type;
    }
  }

  /* ------------------------------------------------------------ pointer UI */
  var drag = null;

  function pointToMm(ev) {
    var rect = canvas.getBoundingClientRect();
    var pxPerMm = currentScale();
    return { x: (ev.clientX - rect.left) / pxPerMm, y: (ev.clientY - rect.top) / pxPerMm };
  }

  function hitTest(pt) {
    for (var i = state.elements.length - 1; i >= 0; i--) {
      var b = bounds(state.elements[i]);
      var pad = 1;
      if (pt.x >= b.x - pad && pt.x <= b.x + b.w + pad && pt.y >= b.y - pad && pt.y <= b.y + b.h + pad) return state.elements[i];
    }
    return null;
  }

  function onHandle(pt, e) {
    if (!e) return false;
    var b = bounds(e);
    var pxPerMm = currentScale();
    var hx = b.x + b.w, hy = b.y + b.h;
    var tol = 8 / pxPerMm;
    return Math.abs(pt.x - hx) < tol && Math.abs(pt.y - hy) < tol;
  }

  function stripImg(e) {
    var copy = {};
    Object.keys(e).forEach(function (k) { if (k !== '_img') copy[k] = e[k]; });
    return copy;
  }

  function bindCanvas() {
    /* Clicking the face you are not on switches to it rather than trying to drag
       something that is not there. */
    $$('[data-eld-face]').forEach(function (f) {
      f.addEventListener('pointerdown', function (ev) {
        var side = f.getAttribute('data-eld-face');
        if (side !== state.side) { ev.stopPropagation(); ev.preventDefault(); switchSide(side); }
      }, true);
    });

    Object.keys(canvases).forEach(function (key) { bindOneCanvas(canvases[key]); });
  }

  function bindOneCanvas(canvas) {
    canvas.addEventListener('pointerdown', function (ev) {
      var pt = pointToMm(ev);
      var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
      if (sel && onHandle(pt, sel)) {
        var b0 = bounds(sel);
        drag = { mode: 'resize', el: sel, startPt: pt, start: JSON.parse(JSON.stringify(stripImg(sel))), b0: b0 };
      } else {
        var hit = hitTest(pt);
        selectedId = hit ? hit.id : null;
        if (hit) drag = { mode: 'move', el: hit, startPt: pt, ox: hit.x, oy: hit.y };
        renderLayers();
        renderProps();
      }
      canvas.setPointerCapture(ev.pointerId);
      canvas.classList.toggle('is-grabbing', !!drag);
      draw();
      ev.preventDefault();
    });

    canvas.addEventListener('pointermove', function (ev) {
      var pt = pointToMm(ev);
      if (!drag) {
        var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
        canvas.classList.toggle('is-grab', !!hitTest(pt) || onHandle(pt, sel));
        return;
      }
      var e = drag.el;
      if (drag.mode === 'move') {
        e.x = round1(drag.ox + (pt.x - drag.startPt.x));
        e.y = round1(drag.oy + (pt.y - drag.startPt.y));
      } else {
        var dx = pt.x - drag.startPt.x, dy = pt.y - drag.startPt.y;
        if (e.type === 'qr') e.size = Math.max(4, round1(drag.start.size + Math.max(dx, dy)));
        else if (e.type === 'line') e.w = Math.max(2, round1(drag.start.w + dx));
        else if (e.type === 'text' || e.type === 'serial') e.size = Math.max(1.2, round1(drag.start.size * Math.max(0.15, 1 + dy / Math.max(2, drag.b0.h))));
        else {
          e.w = Math.max(3, round1(drag.start.w + dx));
          e.h = Math.max(3, round1(drag.start.h + dy));
          if (e.type === 'image' && drag.start.w > 0) e.h = round1(e.w * (drag.start.h / drag.start.w));
        }
      }
      draw();
      renderProps(true);
    });

    function endDrag(ev) {
      if (drag) { drag = null; renderLayers(); renderProps(); }
      canvas.classList.remove('is-grabbing');
      if (ev && ev.pointerId != null && canvas.hasPointerCapture && canvas.hasPointerCapture(ev.pointerId)) {
        canvas.releasePointerCapture(ev.pointerId);
      }
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);

    document.addEventListener('keydown', function (ev) {
      if (!selectedId) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      var e = state.elements.filter(function (x) { return x.id === selectedId; })[0];
      if (!e) return;
      var step = ev.shiftKey ? 5 : 0.5;
      var moved = true;
      if (ev.key === 'ArrowLeft') e.x = round1(e.x - step);
      else if (ev.key === 'ArrowRight') e.x = round1(e.x + step);
      else if (ev.key === 'ArrowUp') e.y = round1(e.y - step);
      else if (ev.key === 'ArrowDown') e.y = round1(e.y + step);
      else if (ev.key === 'Delete' || ev.key === 'Backspace') { removeElement(selectedId); moved = false; }
      else moved = false;
      if (moved) { ev.preventDefault(); draw(); renderProps(true); }
    });
  }

  /* Artwork lives on the printable face — the body of a Handy Tag, the wide
     bottom of a Tall Tag — never on the taper, the strap or a fixing hole. */
  function fitBox() {
    var pr = tagDef().print;
    return { x: pr.x, y: pr.y, w: pr.w, h: pr.h };
  }

  /** Refit artwork after the label geometry changes so nothing hangs outside. */
  function clampElements() {
    var box = fitBox();
    state.elements.forEach(function (e) {
      var b = bounds(e);
      var scale = Math.min(1, box.w / Math.max(b.w, 0.001), box.h / Math.max(b.h, 0.001));
      if (scale < 0.999) {
        if (e.type === 'text' || e.type === 'serial') { e.size = round1(e.size * scale); if (e.w) e.w = round1(e.w * scale); }
        else if (e.type === 'qr') e.size = round1(e.size * scale);
        else if (e.type === 'line') e.w = round1(e.w * scale);
        else { e.w = round1(e.w * scale); e.h = round1(e.h * scale); }
        b = bounds(e);
      }
      var maxX = box.x + Math.max(0, box.w - b.w);
      var maxY = box.y + Math.max(0, box.h - b.h);
      var nx = Math.min(Math.max(e.x, box.x), maxX);
      var ny = Math.min(Math.max(e.y, box.y), maxY);
      if (nx !== e.x) e.x = round1(nx);
      if (ny !== e.y) e.y = round1(ny);
    });
  }

  function removeElement(id) {
    state.elements = state.elements.filter(function (e) { return e.id !== id; });
    if (selectedId === id) selectedId = null;
    draw(); renderLayers(); renderProps();
  }

  /* ------------------------------------------------------------ layers UI */
  function renderLayers() {
    var wrap = $('[data-eld-layers]');
    var empty = $('[data-eld-layersempty]');
    wrap.innerHTML = '';
    empty.style.display = state.elements.length ? 'none' : 'block';
    state.elements.slice().reverse().forEach(function (e) {
      var b = el('button', 'eld__layer' + (e.id === selectedId ? ' is-on' : ''));
      b.type = 'button';
      b.innerHTML = '<span class="ico"><svg aria-hidden="true"><use href="#eldi-' +
        (e.type === 'serial' ? 'serial' : e.type) + '"/></svg></span>' +
        '<span class="nm">' + esc(elementName(e)) + '</span>' +
        '<span class="ty">' + esc(e.type) + '</span>';
      b.addEventListener('click', function () {
        selectedId = e.id; renderLayers(); renderProps(); draw();
      });
      wrap.appendChild(b);
    });
  }

  /* ------------------------------------------------------- properties UI */
  function field(labelText, inputHtml, help) {
    return '<div class="eld__field"><span class="eld__label">' + labelText + '</span>' + inputHtml +
      (help ? '<p class="eld__help">' + help + '</p>' : '') + '</div>';
  }

  function renderProps(valuesOnly) {
    var host = $('[data-eld-props]');
    var e = state.elements.filter(function (x) { return x.id === selectedId; })[0];
    if (!e) { host.innerHTML = ''; return; }
    if (valuesOnly && host.dataset.for === e.id) {
      $$('[data-p]', host).forEach(function (input) {
        var key = input.getAttribute('data-p');
        if (input.type === 'checkbox') input.checked = !!e[key];
        else if (document.activeElement !== input) input.value = e[key];
      });
      return;
    }

    var html = '<div class="eld__props" data-for="' + e.id + '"><h4>' + esc(elementName(e)) +
      '<span class="eld__btnrow">' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-move="up" aria-label="Bring forward"><svg aria-hidden="true"><use href="#eldi-up"/></svg></button>' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-move="down" aria-label="Send backward"><svg aria-hidden="true"><use href="#eldi-down"/></svg></button>' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-del aria-label="Delete element"><svg aria-hidden="true"><use href="#eldi-trash"/></svg></button>' +
      '</span></h4>';

    if (e.type === 'text') {
      html += field('Text', '<textarea data-p="text" rows="2">' + esc(e.text) + '</textarea>');
      html += '<div class="eld__row-3">' +
        field('Size (mm)', '<input type="number" step="0.1" min="1" data-p="size" value="' + e.size + '">') +
        field('Weight', '<select data-p="weight"><option value="400">Regular</option><option value="600">Semibold</option><option value="700">Bold</option><option value="800">Extra bold</option></select>') +
        field('Align', '<select data-p="align"><option value="left">Left</option><option value="center">Centre</option><option value="right">Right</option></select>') +
        '</div>';
      html += '<div class="eld__row">' +
        field('Wrap width (mm)', '<input type="number" step="0.5" min="4" data-p="w" value="' + e.w + '">') +
        field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">') +
        '</div>';
    } else if (e.type === 'serial') {
      html += '<div class="eld__row-3">' +
        field('Prefix', '<input type="text" data-p="prefix" value="' + esc(e.prefix) + '">') +
        field('Start at', '<input type="number" min="0" step="1" data-p="start" value="' + e.start + '">') +
        field('Digits', '<input type="number" min="1" max="12" step="1" data-p="digits" value="' + e.digits + '">') +
        '</div>';
      html += '<div class="eld__row">' +
        field('Suffix', '<input type="text" data-p="suffix" value="' + esc(e.suffix) + '">') +
        field('Size (mm)', '<input type="number" step="0.1" min="1" data-p="size" value="' + e.size + '">') +
        '</div>';
      html += field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">',
        'The preview shows the first label. We print the full sequence across your run.');
    } else if (e.type === 'barcode') {
      html += field('Symbology', '<select data-p="symbology"><option value="code128">Code 128 &mdash; letters and numbers</option><option value="ean13">EAN-13 &mdash; retail, 13 digits</option></select>');
      html += field('Value', '<input type="text" data-p="value" value="' + esc(e.value) + '">');
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="5" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="4" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<label class="eld__check"><input type="checkbox" data-p="showText"' + (e.showText ? ' checked' : '') + '><span>Print the number underneath</span></label>';
    } else if (e.type === 'qr') {
      html += field('Content', '<input type="text" data-p="value" value="' + esc(e.value) + '">', 'A web address, part number or any short text.');
      html += '<div class="eld__row">' +
        field('Size (mm)', '<input type="number" step="0.5" min="6" data-p="size" value="' + e.size + '">') +
        field('Error correction', '<select data-p="ec"><option value="L">L &mdash; smallest</option><option value="M">M &mdash; standard</option><option value="Q">Q &mdash; rugged</option></select>') +
        '</div>';
    } else if (e.type === 'image') {
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="3" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="3" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<p class="eld__help">Your file stays in your browser for the proof. Email the print-ready original (vector, or 300&thinsp;dpi and up) to ' +
        esc(CFG.email || 'sales@earlsmere.co.uk') + ' when you send the enquiry.</p>';
    } else if (e.type === 'box') {
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="2" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="2" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<div class="eld__row-3">' +
        field('Line (mm)', '<input type="number" step="0.1" min="0" data-p="strokeW" value="' + e.strokeW + '">') +
        field('Line colour', '<input type="color" data-p="stroke" value="' + e.stroke + '">') +
        field('Radius (mm)', '<input type="number" step="0.5" min="0" data-p="radius" value="' + e.radius + '">') +
        '</div>';
      html += field('Fill', '<select data-p="fill"><option value="none">No fill</option><option value="#000000">Black</option><option value="#ffffff">White</option><option value="#00A0DF">Earlsmere blue</option><option value="#ffe14d">Yellow</option><option value="#e8443a">Red</option></select>');
    } else if (e.type === 'line') {
      html += '<div class="eld__row-3">' +
        field('Length (mm)', '<input type="number" step="0.5" min="2" data-p="w" value="' + e.w + '">') +
        field('Thickness', '<input type="number" step="0.1" min="0.1" data-p="thickness" value="' + e.thickness + '">') +
        field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">') +
        '</div>';
    }

    html += '<div class="eld__row-3">' +
      field('X (mm)', '<input type="number" step="0.5" data-p="x" value="' + e.x + '">') +
      field('Y (mm)', '<input type="number" step="0.5" data-p="y" value="' + e.y + '">') +
      '<div class="eld__field"><span class="eld__label">&nbsp;</span><button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-centre style="width:100%">Centre</button></div>' +
      '</div>';
    html += '</div>';

    host.innerHTML = html;
    host.dataset.for = e.id;

    $$('[data-p]', host).forEach(function (input) {
      var key = input.getAttribute('data-p');
      if (input.tagName === 'SELECT') input.value = String(e[key]);
      if (input.type === 'checkbox') input.checked = !!e[key];
      var evName = (input.tagName === 'SELECT' || input.type === 'checkbox' || input.type === 'color') ? 'change' : 'input';
      input.addEventListener(evName, function () {
        var v;
        if (input.type === 'checkbox') v = input.checked;
        else if (input.type === 'number') v = parseFloat(input.value);
        else v = input.value;
        if (input.type === 'number' && !isFinite(v)) return;
        if (key === 'weight' || key === 'digits' || key === 'start') v = parseInt(input.value, 10) || 0;
        e[key] = v;
        draw(); renderLayers();
      });
    });

    $('[data-del]', host).addEventListener('click', function () { removeElement(e.id); });
    $('[data-centre]', host).addEventListener('click', function () {
      var b = bounds(e);
      e.x = round1((labelW() - b.w) / 2);
      e.y = round1((labelH() - b.h) / 2);
      draw(); renderProps();
    });
    $$('[data-move]', host).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = state.elements.indexOf(e);
        var j = btn.getAttribute('data-move') === 'up' ? i + 1 : i - 1;
        if (j < 0 || j >= state.elements.length) return;
        state.elements.splice(i, 1);
        state.elements.splice(j, 0, e);
        draw(); renderLayers();
      });
    });
  }

  function specRows() {
    var t = tagDef(), run = runInfo();
    var rows = [
      ['Tag', t.name + ' (' + fmtMm(t.w) + ' × ' + fmtMm(t.h) + ' mm)'],
      ['Colour', colourDef().name],
      ['Print', LABELS.sides[state.sides] + ', laser etched'],
      ['Quantity', fmtInt(run.qty) + ' tags'],
      ['Price each', fmtMoney(run.unit) + ' ex VAT'],
      ['Total', fmtMoney(run.total) + ' ex VAT']
    ];
    var counts = {};
    countBoth(function (e) { counts[e.type] = (counts[e.type] || 0) + 1; });
    var art = Object.keys(counts).map(function (k) { return counts[k] + ' × ' + k; }).join(', ');
    rows.push(['Artwork', art || 'None yet']);
    if (state.reference) rows.push(['Your reference', state.reference]);
    return rows;
  }

  function renderSummary() {
    var host = $('[data-eld-summary]');
    host.innerHTML = '<dl>' + specRows().map(function (r) {
      return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>';
    }).join('') + '</dl>';
  }

  function specText() {
    var lines = specRows().map(function (r) { return r[0] + ': ' + r[1]; });
    sideList().forEach(function (side) {
      var els = (side === state.side ? state.elements : state.stored[side]) || [];
      lines.push('');
      lines.push(LABELS.side[side].toUpperCase() + (els.length ? '' : ' — blank'));
      els.forEach(function (e, i) {
        var d = '  ' + (i + 1) + '. ' + e.type + ' @ ' + fmtMm(e.x) + ',' + fmtMm(e.y) + 'mm';
        if (e.type === 'text') d += ' — "' + String(e.text).replace(/\n/g, ' / ') + '" ' + e.size + 'mm';
        if (e.type === 'serial') d += ' — ' + serialSample(e) + ' incrementing';
        if (e.type === 'barcode') d += ' — ' + (e.symbology === 'ean13' ? 'EAN-13' : 'Code 128') + ' "' + e.value + '" ' + fmtMm(e.w) + '×' + fmtMm(e.h) + 'mm';
        if (e.type === 'qr') d += ' — QR "' + e.value + '" ' + fmtMm(e.size) + 'mm';
        if (e.type === 'image') d += ' — customer artwork' + (e.fileName ? ' (' + e.fileName + ')' : '') + ', ' + fmtMm(e.w) + '×' + fmtMm(e.h) + 'mm';
        lines.push(d);
      });
    });
    return lines.join('\n');
  }

  /* The customer's original artwork is far too heavy to travel in an enquiry, so we
     keep a small flattened copy purely so the proof can be rebuilt with their logo on
     it. Print quality is not the point here — recognising the label is. */
  var CODE_IMG_PX = 340;        // longest edge
  var CODE_IMG_MAX = 20000;     // base64 characters we are willing to carry

  function shrinkForCode(img) {
    try {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return '';
      var scale = Math.min(1, CODE_IMG_PX / Math.max(w, h));
      var quality = 0.62;

      for (var attempt = 0; attempt < 5; attempt++) {
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * scale));
        c.height = Math.max(1, Math.round(h * scale));
        var cc = c.getContext('2d');
        cc.fillStyle = colourDef().hex;              // flatten transparency onto the tag
        cc.fillRect(0, 0, c.width, c.height);
        cc.drawImage(img, 0, 0, c.width, c.height);
        var url = c.toDataURL('image/jpeg', quality);
        if (url.length <= CODE_IMG_MAX) return url;
        scale *= 0.72;
        quality = Math.max(0.4, quality - 0.08);
      }
    } catch (err) { /* tainted canvas or no support: fall through */ }
    return '';                                       // too heavy: send the spec without it
  }

  function designCode() {
    try {
      function clean(list) {
        return (list || []).map(function (e) {
          var c = stripImg(e);
          if (c.type === 'image') c.src = e._small || '';
          delete c._small; delete c._etch; delete c._etchKey;
          return c;
        });
      }
      state.stored[state.side] = state.elements;
      var payload = {
        v: 3, kind: 'tag',
        tag: state.tag, colour: state.colour, sides: state.sides,
        quantity: state.quantity, reference: state.reference,
        front: clean(state.stored.front),
        back: state.sides === 'double' ? clean(state.stored.back) : []
      };
      return btoa(unescape(encodeURIComponent(JSON.stringify(JSON.parse(JSON.stringify(payload))))));
    } catch (err) { return ''; }
  }

  /* A link that reopens this exact label with its proof on screen. Long designs
     would make a URL that email clients wrap and break, so past a safe length we
     fall back to the pasteable code alone. */
  var MAX_LINK_CHARS = 1900;

  /* ----------------------------------------------------------- proof export */
  function proofDataUrl() {
    var pxPerMm = PROOF_DPI / 25.4;
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(labelW() * pxPerMm));
    c.height = Math.max(1, Math.round(labelH() * pxPerMm));
    var cc = c.getContext('2d');
    renderTo(cc, pxPerMm, { guides: false, selection: false });
    return c.toDataURL('image/png');
  }

  /* On claude.ai the page cannot start a download itself, so use the host's
     save surface when it is offered. Everywhere else (your Shopify store, a
     local file) the ordinary download link is exactly right. */
  var hostSave = null;
  if (window.claude && typeof window.claude.use === 'function') {
    try { window.claude.use('downloads').then(function (d) { hostSave = d; }, function () {}); }
    catch (err) { /* nothing to do */ }
  }

  function dataUrlToBytes(url) {
    var b64 = url.split(',')[1] || '';
    var bin = atob(b64);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }

  function saveProof(url, btn) {
    var filename = 'earlsmere-label-' + fmtMm(labelW()) + 'x' + fmtMm(labelH()) + 'mm.png';
    if (hostSave && typeof hostSave.save === 'function') {
      btn.disabled = true;
      hostSave.save({ filename: filename, data: dataUrlToBytes(url) })
        .then(function () { btn.disabled = false; })
        .catch(function (err) {
          btn.disabled = false;
          if (err && err.code === 'declined') return;
          window.alert('That download was not allowed here. Right-click the proof and choose "Save image as…" instead.');
        });
      return;
    }
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  function openProof() {
    var url = proofDataUrl();
    $('[data-eld-proofimg]').src = url;
    $('[data-eld-proofmeta]').textContent =
      tagDef().name + ' · ' + fmtMm(labelW()) + ' × ' + fmtMm(labelH()) + ' mm · ' +
      colourDef().name.toLowerCase() + ' · ' + LABELS.sides[state.sides].toLowerCase() +
      (state.sides === 'double' ? ' (' + LABELS.side[state.side].toLowerCase() + ' shown)' : '');
    $('[data-eld-modal]').classList.add('is-open');
    var btn = $('[data-eld-proofdl]');
    btn.onclick = function () { saveProof(url, btn); };
  }

  function setStep(name) {
    $$('[data-eld-tab]').forEach(function (b) {
      var on = b.getAttribute('data-eld-tab') === name;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('.eld__step').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-eld-panel') === name);
    });
    if (name === 'order') renderSummary();
    if (name === 'quantity') renderPrice();
    var hints = {
      tag: 'Pick the tag and colour first — the artwork area changes with it.',
      design: state.elements.length
        ? 'Click an element to select it, then drag to move. Arrow keys nudge.'
        : 'Add text, a logo or a barcode above to start laying out this side.',
      quantity: 'Every tag is made to order, so there is no minimum and no setup charge.',
      order: 'Your design goes on the order, so we etch exactly what you see here.'
    };
    $('[data-eld-stagehint]').textContent = hints[name] || '';
  }

  function syncQtyChips() {
    $$('[data-eld-qtychips] .eld__chip').forEach(function (b, i) {
      b.classList.toggle('is-on', QTY_CHIPS[i] === Number(state.quantity));
    });
  }

  function bindInputs() {
    $$('[data-eld]').forEach(function (input) {
      var key = input.getAttribute('data-eld');
      if (state[key] != null) input.value = state[key];
      input.addEventListener('input', function () {
        if (input.type === 'number') state[key] = num(input.value, 1, 1000000, state[key]);
        else state[key] = input.value;
        if (key === 'quantity') { syncQtyChips(); renderPrice(); }
        if (key === 'reference') renderSummary();
      });
      if (input.type === 'number') {
        input.addEventListener('change', function () {
          if (String(state[key]) !== input.value) input.value = state[key];
        });
      }
    });

    function syncOptCards() {
      $$('.eld__opt').forEach(function (lab) {
        var i = lab.querySelector('input');
        lab.classList.toggle('is-on', !!(i && i.checked));
      });
    }
    $$('.eld__opt input').forEach(function (i) { i.addEventListener('change', syncOptCards); });
    syncOptCards();

    $$('input[name="eld-sides"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) setSides(r.value); });
    });
    $$('[data-eld-side]').forEach(function (b) {
      b.addEventListener('click', function () { switchSide(b.getAttribute('data-eld-side')); });
    });

    $$('[data-eld-tab]').forEach(function (b) {
      b.addEventListener('click', function () { setStep(b.getAttribute('data-eld-tab')); });
    });
    $$('[data-eld-next]').forEach(function (b) {
      b.addEventListener('click', function () { setStep(b.getAttribute('data-eld-next')); });
    });

    $$('[data-eld-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var type = b.getAttribute('data-eld-add');
        if (type === 'image') { $('[data-eld-file]').click(); return; }
        makeElement(type);
        draw(); renderLayers(); renderProps();
      });
    });

    QTY_CHIPS.forEach(function (q) {
      var b = el('button', 'eld__chip', fmtInt(q));
      b.type = 'button';
      b.addEventListener('click', function () {
        state.quantity = q;
        $('[data-eld="quantity"]').value = q;
        syncQtyChips(); renderPrice();
      });
      $('[data-eld-qtychips]').appendChild(b);
    });

    $('[data-eld-guides]').addEventListener('change', function () {
      showGuides = this.checked; draw();
    });

    $('[data-eld-file]').addEventListener('change', function () {
      var file = this.files && this.files[0];
      if (!file) return;
      if (file.size > 6 * 1024 * 1024) {
        window.alert('That file is over 6 MB. Please use a smaller version.');
        this.value = '';
        return;
      }
      var reader = new FileReader();
      reader.onload = function (ev) {
        var img = new Image();
        img.onload = function () {
          var box = fitBox();
          var maxW = box.w * 0.7;
          var ratio = img.naturalHeight / img.naturalWidth;
          var e = makeElement('image', { src: ev.target.result, w: round1(maxW), h: round1(maxW * ratio) });
          e._img = img;
          e.fileName = file.name;
          e._small = shrinkForCode(img);
          clampElements();
          draw(); renderLayers(); renderProps();
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
      this.value = '';
    });

    $$('[data-eld-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var base = currentScale();
        zoom = b.getAttribute('data-eld-zoom') === '+' ? base * 1.25 : base / 1.25;
        if (zoom < fitScale() * 0.55) zoom = 0;
        draw();
      });
    });

    $('[data-eld-proof]').addEventListener('click', openProof);
    $$('[data-eld-close]').forEach(function (b) {
      b.addEventListener('click', function () { $('[data-eld-modal]').classList.remove('is-open'); });
    });
    $('[data-eld-modal]').addEventListener('click', function (ev) {
      if (ev.target === this) this.classList.remove('is-open');
    });

    var addBtn = $('[data-eld-addcart]');
    if (addBtn) addBtn.addEventListener('click', addToBasket);

    var codeLoad = $('[data-eld-codeload]');
    if (codeLoad) codeLoad.addEventListener('click', function () {
      var box = $('[data-eld-codein]');
      var msg = $('[data-eld-codemsg]');
      var raw = (box.value || '').replace(/\s+/g, '');
      if (!raw) { msg.textContent = 'Paste a code first.'; return; }
      if (loadCode(raw)) {
        msg.textContent = 'Rebuilt — opening the proof.';
        window.setTimeout(function () { draw(); openProof(); }, 160);
      } else {
        msg.textContent = 'That code could not be read. Copy the whole thing and try again.';
      }
    });
  }

  /* ------------------------------------------------------------- tag chooser */
  function renderTagTypes() {
    var host = $('[data-eld-tagtypes]');
    if (!host) return;
    host.innerHTML = '';
    Object.keys(TAGS).forEach(function (key) {
      var t = TAGS[key];
      var lab = el('label', 'eld__opt' + (state.tag === key ? ' is-on' : ''));
      lab.innerHTML = '<input type="radio" name="eld-tagtype" value="' + key + '"' +
        (state.tag === key ? ' checked' : '') + '>' +
        '<span class="t">' + esc(t.name) + '</span>' +
        '<span class="d">' + fmtMm(t.w) + ' × ' + fmtMm(t.h) + ' mm. ' + esc(t.blurb) + '</span>';
      lab.querySelector('input').addEventListener('change', function () { setTagType(key); });
      host.appendChild(lab);
    });
    var note = $('[data-eld-tagnote]');
    if (note) {
      var h = holeGeom();
      note.innerHTML = h
        ? '<strong>The fixing hole is kept clear.</strong> Artwork sits on the body below the punch, so nothing you place gets cut through.'
        : '<strong>Printing goes on the face at the bottom.</strong> The strap and its slots stay clear, so the tag still threads and locks properly.';
    }
  }

  function setTagType(key) {
    if (!TAGS[key] || key === state.tag) return;
    var from = fitBox();
    state.tag = key;
    /* If the new tag isn't moulded in the colour they had picked, drop to the
       first one that it is, rather than quietly showing a colour we can't make. */
    var avail = tagColours();
    if (!avail.some(function (c) { return c.key === state.colour; })) {
      state.colour = avail[0].key;
      countBoth(function (e) { e._etch = null; });
    }
    var to = fitBox();
    /* Move artwork proportionally into the new printable face rather than just
       shoving it inside — a layout should survive changing your mind. */
    var sx = to.w / from.w, sy = to.h / from.h, sc = Math.min(sx, sy);
    ['front', 'back'].forEach(function (side) {
      var list = side === state.side ? state.elements : state.stored[side];
      (list || []).forEach(function (e) {
        e.x = round1(to.x + (e.x - from.x) * sx);
        e.y = round1(to.y + (e.y - from.y) * sy);
        ['w', 'h', 'size'].forEach(function (k) {
          if (typeof e[k] === 'number') e[k] = round1(e[k] * sc);
        });
        e._etch = null;
      });
    });
    clampElements();
    renderTagTypes(); renderColours(); renderPrice(); renderSummary();
    zoom = 0;
    draw(); renderLayers(); renderProps();
  }

  function renderColours() {
    var host = $('[data-eld-colours]');
    if (!host) return;
    host.innerHTML = '';
    tagColours().forEach(function (c) {
      var b = el('button', 'eld__swatch' + (state.colour === c.key ? ' is-on' : ''));
      b.type = 'button';
      b.title = c.name;
      b.setAttribute('aria-label', c.name);
      b.setAttribute('aria-pressed', state.colour === c.key ? 'true' : 'false');
      b.innerHTML = '<span class="sw" style="background:' + c.hex + '"></span><span class="nm">' + esc(c.name) + '</span>';
      b.addEventListener('click', function () {
        state.colour = c.key;
        countBoth(function (e) { e._etch = null; });     // etch tone follows the tag colour
        renderColours(); renderSummary(); draw();
      });
      host.appendChild(b);
    });
  }

  /* ------------------------------------------------------------------ sides */
  function setSides(v) {
    state.sides = v === 'double' ? 'double' : 'single';
    if (state.sides === 'single' && state.side === 'back') switchSide('front');
    setActiveCanvas();
    applySidesUI();
    renderPrice(); renderSummary(); draw();
  }

  function applySidesUI() {
    var field = $('[data-eld-sidefield]');
    if (field) field.style.display = state.sides === 'double' ? '' : 'none';
    $$('[data-eld-side]').forEach(function (b) {
      var on = b.getAttribute('data-eld-side') === state.side;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });
    var pS = $('[data-eld-price-single]'), pD = $('[data-eld-price-double]');
    if (pS) pS.textContent = 'Front only — ' + fmtMoney(PRICES[state.tag].single) + ' a tag';
    if (pD) pD.textContent = 'Front and back — ' + fmtMoney(PRICES[state.tag].double) + ' a tag';
  }

  /* `canvas`/`ctx` always point at the face being worked on, so the drag,
     hit-test and measuring code below needs no idea there are two. */
  function setActiveCanvas() {
    canvas = canvases[state.side] || canvases.front;
    ctx = canvas.getContext('2d');
  }

  function switchSide(side) {
    if (side !== 'front' && side !== 'back') return;
    state.stored[state.side] = state.elements;
    state.side = side;
    state.elements = state.stored[side] || (state.stored[side] = []);
    selectedId = null;
    setActiveCanvas();
    applySidesUI();
    draw(); renderLayers(); renderProps();
  }

  /* ------------------------------------------------------------------ price */
  function renderPrice() {
    var run = runInfo();
    var host = $('[data-eld-priceinfo]');
    if (host) {
      host.innerHTML = '<div class="eld__note"><strong>' + fmtInt(run.qty) + ' tags at ' +
        fmtMoney(run.unit) + ' each</strong> — ' + fmtMoney(run.total) + ' ex VAT. ' +
        esc(tagDef().name) + ', ' + esc(LABELS.sides[state.sides].toLowerCase()) +
        '. No minimum order and no setup charge.</div>';
    }
    var total = $('[data-eld-total]');
    if (total) {
      total.innerHTML = '<span class="lbl">' + fmtInt(run.qty) + ' × ' + esc(tagDef().name) + '</span>' +
        '<span class="amt">' + fmtMoney(run.total) + '</span>' +
        '<span class="vat">ex VAT</span>';
    }
    applySidesUI();
  }

  /* --------------------------------------------------------------- basket */
  function designRef() {
    var s = 'ELD-';
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    for (var i = 0; i < 5; i++) s += chars[Math.floor(Math.random() * chars.length)];
    return s;
  }

  function addToBasket() {
    var out = $('[data-eld-cartresult]');
    var btn = $('[data-eld-addcart]');
    var run = runInfo();
    var empty = 0;
    countBoth(function () { empty++; });
    if (!empty) {
      out.innerHTML = '<div class="eld__note eld__note--warn">Add something to the tag first — text, a logo or a barcode.</div>';
      setStep('design');
      return;
    }
    var id = variantId();
    if (!id) {
      out.innerHTML = '<div class="eld__note eld__note--warn">This tag is not linked to a product yet. ' +
        'Add the variant IDs in the theme settings, or call ' + esc(CFG.phone || '01226 750 111') + '.</div>';
      return;
    }

    var ref = designRef();
    var props = {
      'Tag': tagDef().name,
      'Colour': colourDef().name,
      'Print': LABELS.sides[state.sides],
      'Design ref': ref
    };
    if (state.reference) props['Your reference'] = state.reference;
    props['_design'] = designCode();
    props['_spec'] = specText();

    btn.disabled = true;
    btn.innerHTML = '<span class="eld__spinner"></span>Adding…';

    function done(ok, msg) {
      btn.disabled = false;
      btn.textContent = 'Add to basket';
      out.innerHTML = ok
        ? '<div class="eld__note eld__note--good"><strong>Added to your basket.</strong> ' +
          fmtInt(run.qty) + ' × ' + esc(tagDef().name) + ', ' + fmtMoney(run.total) + ' ex VAT. ' +
          'Your design travels with the order under reference <strong>' + esc(ref) + '</strong>. ' +
          '<a href="/cart">View basket</a></div>'
        : '<div class="eld__note eld__note--warn"><strong>That did not add.</strong> ' + esc(msg || '') +
          ' Please try again, or call ' + esc(CFG.phone || '01226 750 111') + '.</div>';
    }

    if (!IS_SHOPIFY) {
      window.setTimeout(function () {
        done(true);
        out.insertAdjacentHTML('beforeend',
          '<div class="eld__note" style="margin-top:9px">This is the preview build, so nothing was really added.</div>');
      }, 450);
      return;
    }

    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: run.qty, properties: props }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      if (!res.ok) { done(false, (res.body && (res.body.description || res.body.message)) || ''); return; }
      done(true);
      document.dispatchEvent(new CustomEvent('eld:added', { detail: res.body }));
    }).catch(function (err) { done(false, String(err)); });
  }

  /* ------------------------------------------------------------------ init */
  function init() {
    root = document.querySelector('[data-eld]');
    if (!root) return;
    canvases.front = $('[data-eld-canvas="front"]');
    canvases.back = $('[data-eld-canvas="back"]');
    setActiveCanvas();

    var t = $('[data-eld-tel]');
    if (t && CFG.phone) { t.textContent = CFG.phone; t.href = 'tel:' + CFG.phone.replace(/\s/g, ''); }
    if (CFG.heading) $('[data-eld-title]').textContent = CFG.heading;
    if (CFG.intro) $('[data-eld-intro]').textContent = CFG.intro;
    if (CFG.hideHeading) $('[data-eld-head]').style.display = 'none';

    /* A product page can drop someone straight onto the right tag with
       ?tag=site, so "Start designing" lands where the customer expects. */
    try {
      var want = (String(location.search).match(/[?&]tag=([a-z]+)/i) || [])[1];
      if (want && TAGS[want.toLowerCase()]) {
        state.tag = want.toLowerCase();
        var av = tagColours();
        if (!av.some(function (c) { return c.key === state.colour; })) state.colour = av[0].key;
      }
    } catch (err) { /* a bad query string is not a reason to fail to load */ }

    bindInputs();
    bindCanvas();
    renderTagTypes();
    renderColours();
    applySidesUI();
    syncQtyChips();
    renderPrice();
    renderLayers();
    renderProps();
    draw();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(draw, 120);
    });

    root.setAttribute('data-eld-ready', 'true');
  }

  /* Rebuild a tag from the design code that travels on the order. */
  function loadCode(code) {
    var data;
    try { data = JSON.parse(decodeURIComponent(escape(atob(String(code).trim())))); }
    catch (err) { return false; }
    if (!data || data.v !== 3 || data.kind !== 'tag') return false;

    if (TAGS[data.tag]) state.tag = data.tag;
    if (data.colour) state.colour = data.colour;
    var okCols = tagColours();
    if (!okCols.some(function (c) { return c.key === state.colour; })) state.colour = okCols[0].key;
    state.sides = data.sides === 'double' ? 'double' : 'single';
    if (data.quantity) state.quantity = data.quantity;
    state.reference = data.reference || '';

    function build(list) {
      return (list || []).map(function (e) {
        var copy = Object.assign({}, e);
        copy.id = 'e' + (++uid);
        if (copy.type === 'image' && copy.src) {
          var img = new Image();
          img.onload = draw;
          img.src = copy.src;
          copy._img = img;
          copy._small = copy.src;
        }
        return copy;
      });
    }
    state.stored.front = build(data.front);
    state.stored.back = build(data.back);
    state.side = 'front';
    state.elements = state.stored.front;
    selectedId = null;

    $$('input[name="eld-sides"]').forEach(function (r) { r.checked = r.value === state.sides; });
    $$('.eld__opt').forEach(function (lab) {
      var i = lab.querySelector('input');
      lab.classList.toggle('is-on', !!(i && i.checked));
    });
    var q = $('[data-eld="quantity"]'); if (q) q.value = state.quantity;
    var rf = $('[data-eld="reference"]'); if (rf) rf.value = state.reference;

    renderTagTypes(); renderColours(); applySidesUI();
    syncQtyChips(); renderPrice(); renderSummary();
    renderLayers(); renderProps(); draw();
    return true;
  }

  window.ELD_LOAD = loadCode;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
